interface EmptyMessageProps {
  message: string
  className?: string
}

export default function EmptyMessage({
  message,
  className = "",
}: Readonly<EmptyMessageProps>) {
  return (
    <p
      role="status"
      aria-live="polite"
      className={`app-txt-body1 py-12 text-center text-app-text-200 ${className}`}
    >
      {message}
    </p>
  )
}
